import Partner_1 from "./1.png";
import Partner_2 from "./2.png";
import Partner_3 from "./3.png";
import Partner_4 from "./4.png";
import Partner_5 from "./5.png";
import Partner_6 from "./6.png";
import Partner_7 from "./7.png";
import Partner_8 from "./8.png";
import Partner_9 from "./9.png";
import Partner_10 from "./10.png";
import Partner_11 from "./11.png";
import Partner_12 from "./12.png";
import Partner_13 from "./13.png";
import Partner_14 from "./14.png";
import Partner_15 from "./15.png";
import Partner_16 from "./16.png";
import Partner_17 from "./17.png";
import Partner_18 from "./18.png";
import Partner_19 from "./19.png";
import Partner_20 from "./20.png";
import Partner_21 from "./21.png";
import Partner_22 from "./22.png";
import Partner_23 from "./23.png";
import Partner_24 from "./24.png";
import Partner_25 from "./25.png";
import Partner_26 from "./26.png";
import Partner_27 from "./27.png";
import Partner_28 from "./28.png";
import Partner_29 from "./29.png";
import Partner_30 from "./30.png";
import Partner_31 from "./31.png";
import Partner_32 from "./32.png";
import Partner_33 from "./33.png";
import Partner_34 from "./34.png";
import Partner_35 from "./35.png";
import Partner_36 from "./36.png";
import Partner_37 from "./37.png";
import Partner_38 from "./38.png";
import Partner_39 from "./39.png";
import Partner_40 from "./40.png";
import Partner_41 from "./41.png";
import Partner_42 from "./42.png";

export const partners = [
  // Top Row Images
  Partner_1,
  Partner_5,
  Partner_3,
  Partner_38,
  Partner_26,
  Partner_32,
  Partner_10,
  Partner_40,
  Partner_29,
  Partner_34,
  Partner_15,
  Partner_39,
  Partner_25,
  Partner_21,
  Partner_42,
  Partner_22,
  Partner_19,
  Partner_18,
  Partner_14,
  Partner_28,

  // Bottom Row Images
  Partner_6,
  Partner_8,
  Partner_36,
  Partner_33,
  Partner_7,
  Partner_4,
  Partner_16,
  Partner_2,
  Partner_13,
  Partner_24,
  Partner_20,
  Partner_23,
  Partner_41,
  Partner_35,
  Partner_9,
  Partner_37,
  Partner_31,
];

export const aboutUsPartners = [
  Partner_1,
  Partner_5,
  Partner_3,
  Partner_38,
  Partner_6,
  Partner_8,
  Partner_36,
  Partner_33,
];

export const clients = [
  Partner_1,
  Partner_5,
  Partner_3,
  Partner_38,
  Partner_6,
  Partner_8,
  Partner_36,
  Partner_33,
  Partner_26,
  Partner_32,
  Partner_10,
  Partner_40,
  Partner_7,
  Partner_4,
  Partner_16,
  Partner_2,
  Partner_13,
  Partner_29,
  Partner_34,
  Partner_15,
  Partner_39,
  Partner_24,
  Partner_20,
  Partner_23,
  Partner_41,
  Partner_25,
  Partner_21,
  Partner_42,
  Partner_22,
  Partner_35,
  Partner_9,
  Partner_37,
  Partner_31,
  Partner_19,
  Partner_18,
  Partner_14,
  Partner_28,
];
